import { ComponentChildren, h } from 'preact';
import styled from 'styled-components';
import { backgroundColors, breakpoints, colors } from '../util/variables';

interface ButtonProps {
	onClick?: () => void;
	type?: 'button' | 'submit';
	variant?: 'primary' | 'secondary' | 'red';
	disabled?: boolean;
	ariaLabel?: string;
	children: ComponentChildren;
	fullWidth?: boolean;
}

const getColor = (type: any) => {
	if (type === 'primary') {
		return backgroundColors.black;
	} else if (type === 'red') {
		return backgroundColors.red;
	} else return backgroundColors.white;
};

const getTextColor = (type: any) => {
	if (type === 'primary') {
		return backgroundColors.white;
	} else if (type === 'red') {
		return backgroundColors.white;
	} else return backgroundColors.black;
};

const getBorderColor = (type: any) => {
	if (type === 'red') {
		return backgroundColors.red;
	} else {
		return backgroundColors.black;
	}
};

const ButtonStyled = styled.button<ButtonProps>`
	background: ${({ variant }) => getColor(variant)};
	border: 1px solid ${({ variant }) => getBorderColor(variant)};
	color: ${({ variant }) => getTextColor(variant)};
	display: ${({ fullWidth }) => (fullWidth ? 'block' : 'inline-block')};
	font-weight: 800;
	cursor: pointer;
	font-size: 14px;
	line-height: 1.5;
	padding: 12px 16px;
	text-align: center;
	width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
	-webkit-appearance: none;
	-moz-appearance: none;

	&:disabled,
	[disabled] {
		background: #e0e0e0;
		border-color: #e0e0e0;
		color: #636363;
	}

	@media screen and (min-width: ${breakpoints.md}) {
		padding: 16px;
	}
`;

export const Button = ({
	onClick = () => null,
	children,
	type = 'button',
	variant = 'primary',
	fullWidth = false,
	ariaLabel,
	disabled,
}: ButtonProps) => {
	return (
		<ButtonStyled
			aria-label={ariaLabel}
			role="button"
			type={type}
			onClick={onClick}
			disabled={disabled}
			variant={variant}
			fullWidth={fullWidth}
		>
			{children}
		</ButtonStyled>
	);
};
